import React from 'react';
import S from './style';

function AddButton({ children, ...properties }) {
  return (
    <S.AddButton {...properties}>
      <S.AddIcon /> {children}
    </S.AddButton>
  );
}

export default AddButton;
